// extracted by mini-css-extract-plugin
module.exports = {"coverContainer":"blog-post_coverContainer__Xske6","neonSignContainer":"blog-post_neonSignContainer__YegOD","bodyNoCol":"blog-post_bodyNoCol__pvpau"};